import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Lottery() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
   const VIDEO_ID = "lottcard"
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
     <CasinoPage
              casino={casinoData?.data}
              VIDEO_ID={VIDEO_ID}
              // VIDEO_ID={GAME_ID}
              GAME_ID={GAME_ID}
              // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
              //  VIDEO_ID={GAME_ID}
              // GAME_ID={GAME_ID}
              // shortName={"cards32a cards32b"}
              // gameName={"CARDS 32B"}
            >
    {/* <div className="center-main-container casino-page"> */}
  {/* <div className="center-container"> */}
    {/* <div className="casino-page-container lottery"> */}
      {/* <div className="casino-header"> */}
        {/* <span className="casino-name">
          Lottery
          <a className="ms-1">
            <small>Rules</small>
          </a>
        </span>
        <span className="casino-rid d-none d-xl-inline-block">
          <small>
            Round ID: <span>133250425141015</span>
          </small>
        </span> */}
      {/* </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none">
        <ul className="nav nav-tabs menu-tabs">
          <li className="nav-item">
            <div className="nav-link active">Game</div>
          </li>
          <li className="nav-item">
            <div className="nav-link">Placed Bet (0)</div>
          </li>
        </ul>
        <div className="pe-2">
          <span className="casino-rid">
            Round ID: <span>133250425141015</span>
          </span>
        </div>
      </div> */}
      {/* <div className=""> */}
        {/* <div className="casino-video"> */}
          {/* <div className="video-box-container"> */}
            {/* <div className="casino-video-box"> */}
              {/* <iframe src="/mediaplayer/lottcard/56c59e15-adbc-484b-afa0-aac6d6f7c06f?ip=122.160.119.41" /> */}
            {/* </div> */}
          {/* </div> */}
          {/* <div className="casino-video-cards"> */}
            {/* <div className=""> */}
              {/* <div className="flip-card-container">
                <div className="flip-card">
                  <div className="flip-card-inner ">
                    <div className="flip-card-front">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                    </div>
                    <div className="flip-card-back">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                    </div>
                  </div>
                </div>
              </div> */}
            {/* </div> */}
            {/* <div className="mt-1">
              <div className="flip-card-container">
                <div className="flip-card">
                  <div className="flip-card-inner ">
                    <div className="flip-card-front">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                    </div>
                    <div className="flip-card-back">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="mt-1">
              <div className="flip-card-container">
                <div className="flip-card">
                  <div className="flip-card-inner ">
                    <div className="flip-card-front">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                    </div>
                    <div className="flip-card-back">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          {/* </div> */}
          {/* <div className="clock flip-clock-wrapper">
            <ul className="flip play">
              <li className="flip-clock-before">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">3</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">3</div>
                  </div>
                </a>
              </li>
              <li className="flip-clock-active">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">2</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">2</div>
                  </div>
                </a>
              </li>
            </ul>
            <ul className="flip play">
              <li className="flip-clock-before">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">4</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">4</div>
                  </div>
                </a>
              </li>
              <li className="flip-clock-active">
                <a href="#">
                  <div className="up">
                    <div className="shadow" />
                    <div className="inn">3</div>
                  </div>
                  <div className="down">
                    <div className="shadow" />
                    <div className="inn">3</div>
                  </div>
                </a>
              </li>
            </ul>
          </div> */}
        {/* </div> */}
        <div className="casino-detail">
          <div className="casino-table">
            <div className="nav nav-pills" role="tablist">
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="single"
                  id="lottery-tabs-tab-single"
                  aria-controls="lottery-tabs-tabpane-single"
                  aria-selected="true"
                  className="nav-link active"
                  tabIndex={0}
                  href="#"
                >
                  Single (0)
                </a>
              </div>
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="double"
                  id="lottery-tabs-tab-double"
                  aria-controls="lottery-tabs-tabpane-double"
                  aria-selected="false"
                  tabIndex={-1}
                  className="nav-link"
                  href="#"
                >
                  Double (0)
                </a>
              </div>
              <div className="nav-item">
                <a
                  role="tab"
                  data-rr-ui-event-key="tripple"
                  id="lottery-tabs-tab-tripple"
                  aria-controls="lottery-tabs-tabpane-tripple"
                  aria-selected="false"
                  tabIndex={-1}
                  className="nav-link"
                  href="#"
                >
                  Tripple (0)
                </a>
              </div>
            </div>
            <div className="w-100 tab-content">
              <div
                role="tabpanel"
                id="lottery-tabs-tabpane-single"
                aria-labelledby="lottery-tabs-tab-single"
                className="fade tab-pane active show"
              >
                <div className="single">
                  <div className="lottery-box">
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/A.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/2.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/3.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/4.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/5.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/6.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/7.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/8.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/9.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/10.png" />
                    </div>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                id="lottery-tabs-tabpane-double"
                aria-labelledby="lottery-tabs-tab-double"
                className="fade tab-pane"
              >
                <div className="double">
                  <div className="lottery-box">
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/A.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/2.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/3.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/4.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/5.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/6.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/7.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/8.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/9.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/10.png" />
                    </div>
                  </div>
                  <div className="random-bets">
                    <h4 className="w-100 text-center mb-1">Random Bets</h4>
                    <button className="lottery-btn active">5</button>
                    <button className="lottery-btn active">10</button>
                    <button className="lottery-btn active">15</button>
                    <button className="lottery-btn active">20</button>
                    <button className="lottery-btn active">25</button>
                    <button className="lottery-btn active">50</button>
                    <button className="lottery-btn active">75</button>
                  </div>
                </div>
              </div>
              <div
                role="tabpanel"
                id="lottery-tabs-tabpane-tripple"
                aria-labelledby="lottery-tabs-tab-tripple"
                className="fade tab-pane"
              >
                <div className="tripple">
                  <div className="lottery-box">
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/A.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/2.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/3.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/4.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/5.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/6.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/7.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/8.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/9.png" />
                    </div>
                    <div className="lottery-card">
                      <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/10.png" />
                    </div>
                  </div>
                  <div className="random-bets">
                    <h4 className="w-100 text-center mb-1">Random Bets</h4>
                    <button className="lottery-btn active">5</button>
                    <button className="lottery-btn active">10</button>
                    <button className="lottery-btn active">15</button>
                    <button className="lottery-btn active">20</button>
                    <button className="lottery-btn active">25</button>
                    <button className="lottery-btn active">50</button>
                    <button className="lottery-btn active">100</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="lottery-buttons d-xl-none">
              <button className="btn btn-lottery">Repeat</button>
              <button className="btn btn-lottery">Clear</button>
              <button className="btn btn-lottery">Remove</button>
            </div>
          </div>
          {/* <div className="casino-last-result-title">
            <span>Last Result</span>
            <span>
              <a href="/casino-results/lottcard">View All</a>
            </span>
          </div>
          <div className="casino-last-results">
            <div className="lottery-result-group">
              <div className="lottery-result-icon">1</div>
              <div className="lottery-result-icon">0</div>
              <div className="lottery-result-icon">1</div>
            </div>
            <div className="lottery-result-group">
              <div className="lottery-result-icon">8</div>
              <div className="lottery-result-icon">2</div>
              <div className="lottery-result-icon">5</div>
            </div>
            <div className="lottery-result-group">
              <div className="lottery-result-icon">5</div>
              <div className="lottery-result-icon">4</div>
              <div className="lottery-result-icon">3</div>
            </div>
            <div className="lottery-result-group">
              <div className="lottery-result-icon">1</div>
              <div className="lottery-result-icon">7</div>
              <div className="lottery-result-icon">5</div>
            </div>
            <div className="lottery-result-group">
              <div className="lottery-result-icon">5</div>
              <div className="lottery-result-icon">9</div>
              <div className="lottery-result-icon">3</div>
            </div>
            <div className="lottery-result-group">
              <div className="lottery-result-icon">4</div>
              <div className="lottery-result-icon">7</div>
              <div className="lottery-result-icon">1</div>
            </div>
            <div className="lottery-result-group">
              <div className="lottery-result-icon">8</div>
              <div className="lottery-result-icon">6</div>
              <div className="lottery-result-icon">7</div>
            </div>
            <div className="lottery-result-group">
              <div className="lottery-result-icon">2</div>
              <div className="lottery-result-icon">9</div>
              <div className="lottery-result-icon">0</div>
            </div>
            <div className="lottery-result-group">
              <div className="lottery-result-icon">7</div>
              <div className="lottery-result-icon">9</div>
              <div className="lottery-result-icon">7</div>
            </div>
            <div className="lottery-result-group">
              <div className="lottery-result-icon">6</div>
              <div className="lottery-result-icon">4</div>
              <div className="lottery-result-icon">7</div>
            </div>
          </div> */}
        </div>
      {/* </div> */}
      <div className="lottery-bets d-none" />
    {/* </div> */}
  {/* </div> */}
  <div className="sidebar right-sidebar lottery-sidebar casino-right-sidebar">
    <div className="lottery-buttons">
      <button className="btn btn-lottery">Repeat</button>
      <button className="btn btn-lottery">Clear</button>
      <button className="btn btn-lottery">Remove</button>
    </div>
    {/* <div className="sidebar-box my-bet-container">
      <div className="sidebar-title">
        <h4>My Bet</h4>
      </div>
      <div className="my-bets lottery-bets" />
    </div> */}
  </div>
{/* </div> */}
</CasinoPage>

  )
}
